export default __webpack_public_path__ + "static/media/our-programs-mobile-hero.f05c8948.png";